<template>
	<div id="afiliado-showroom">

		<ui-spinner v-if="!isFullyLoaded" />

		<template v-else>

			<div class="container oversized-container seller-info-section">
				<div class="row">
					<div class="text-not-found img-holder">
						<img class="logo" :src="seller.logo" />
					</div>
					<div class="textual-holder">
						<h2 class="mb-1 name">{{ seller.nombre }}</h2>
						<div class="box-info text-not-found">
							<p>
								{{ seller.descripcion }}
							</p>
						</div>
					</div>
				</div>
	
			</div>
			
			<!-- SEARCH BAR -->
			<products-search-bar :props-empty-cat-label="`-- Todo ${seller.nombre.trim()} --`" :specific-cats="sellerCats" />
	
			<!-- QUICK TABLE -->
			<products-quicktable class="top-border" v-if="isFullyLoaded"
				:fetchingURI="'inventariocpt/affiliate/' + $route.params.id" />

		</template>

	</div>
</template>

<script>
import axios from 'axios';
import _ from "lodash";
import { mapActions, mapGetters } from "vuex";
import ProductsQuicktable from "../products/ProductsQuicktable.vue";

export default {
	name: "affiliadoShowroom",

	components: {
		ProductsQuicktable,
	},

	data() {
		return {
			isSellerLoaded: true,
			sellerCats: [],
			seller: {
				logo: null,
				nombre: null,
				descripcion: null,
			}
		};
	},

	computed: {
		...mapGetters(["catalogIsLoaded"]),
		isFullyLoaded() {
			return (this.catalogIsLoaded && this.isSellerLoaded)
		}
	},

	methods: {

		...mapActions(["catalogGetSellerByID"]),

		async loadSellerCats() {
			let cats = [];
			try {
				const response = await axios.get('inventariocpt/affiliatecats/' + this.$route.params.id);
				if (response.status)
					cats = response.data.cats;
			} catch (e) {
				console.error(e)
				notify('Error cargando categorías del afiliado')
			} finally {
				this.sellerCats = cats;
			}
		},

		async loadSeller() {
			this.isSellerLoaded = false
			try {
				let fetchedSeller = await this.catalogGetSellerByID(this.$route.params.id);
				await this.loadSellerCats();
				console.log('loadSeller.fetchedSeller', fetchedSeller)
				this.seller = _.merge({}, this.seller, fetchedSeller);
			} catch (e) {
				console.error(e)
			} finally {
				this.isSellerLoaded = true
			}
		}

	},

	mounted() {
		if (this.catalogIsLoaded)
			this.loadSeller()
	},

	watch: {
		catalogIsLoaded(newVal) {
			if (newVal)
				this.loadSeller()
		}
	}

};
</script>

<style lang="scss">
@import '@/sass/utils/_variables';

#afiliado-showroom {
	.top-border {
		border-top: $general-border;
	}

	.row {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		padding: 2em;
		gap: 2em;

		.img-holder {
			margin: 0;

			img {
				width: 10em;
				height: 10em;
			}
		}

		.textual-holder {
			flex: 1;

			h2 {
				color: $primary;
				text-transform: uppercase;
			}
		}
	}

	.logo {
		width: 8em;
		height: 8em;
		object-fit: cover;
		border-radius: 1em;
	}

	.fix-nav-margin {
		margin-top: 01.0em !important;
		// background-color: red;
	}

	.not-found {
		width: 100%;
		text-align: center;
		padding: 70px 10px;
		background-color: #ececec;
		border-radius: 10px;
		margin: 64px;
	}
}
</style>